(function componentForm($, Adzuki)
{
	'use strict';

	var form = {
		name: 'ReservationMoveTravel',
	};

	var $form;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.confirmation = function confirmation(response)
	{
		Adzuki.Erez.ClientDuplicateEmail.confirm(response, form.name);
	};

	form.load = function load()
	{
		$form = $(form.element);

		// Toggle new/existing reservation
		$form.find('.new-existing-reservation').on('change', function change(event) {
			if ($(this).val() === 'new') {
				$form.find('.existing-reservation').addClass('hidden');
				$form.find('.new-reservation').removeClass('hidden');
			} else {
				$form.find('.new-reservation').addClass('hidden');
				$form.find('.existing-reservation').removeClass('hidden');
			}
		});

		// Toggle client opportunity typeahead
		$form.find('.tie-to-client-opportunity').on('change', function change(event) {
			$form.find('.client-opportunity').toggleClass('hidden');
		});

		// Client opportunity typeahead logic
		Adzuki.Typeahead(
			'#reservationmovetravel-client_opportunity_search',
			'/ClientOpportunities/typeaheadSearch',
			function select(item, $self, typeahead) {
				$self.val(item.name);

				typeahead.setHiddenValue(item.id);
			},
			function template(item) {
				return item.name;
			}
		);
	};

}(jQuery, window.Adzuki || {}));
